/**
 * 日付表示の共通フォーマット。
 * 画面ごとに書式がばらつかないよう、日付を出すときは必ずここを通す。
 */

/** `YYYY-MM-DD` → `2026年08月13日` */
export function formatDateJa(dateKey: string): string {
  const [year, month, day] = dateKey.split("-");
  if (year === undefined || month === undefined || day === undefined) return dateKey;
  return `${year}年${month}月${day}日`;
}

/** ISO instant → `2026年08月13日 12:34`(端末のタイムゾーン) */
export function formatDateTimeJa(iso: string): string {
  const date = new Date(iso);
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${String(date.getFullYear())}年${pad(date.getMonth() + 1)}月${pad(date.getDate())}日 ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** 今日の `YYYY-MM-DD`(date input の max などに使う) */
export function todayDateKey(): string {
  const now = new Date();
  return `${String(now.getFullYear())}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}
